import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "preview-title"
}, "视频预览", -1);
var _hoisted_2 = {
  class: "preview-area"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  key: 0,
  class: "preview-footer"
};
var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 关闭 ");
var _hoisted_6 = {
  key: 1,
  class: "preview-footer"
};
var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 重新录制 ");
var _hoisted_8 = /*#__PURE__*/_createTextVNode(" 提交 ");
import { ref } from 'vue';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { ScreenMediaService } from '@/services/recordVideo/media.service';
import { useService } from '@kaokei/use-vue-service';
import { QuestionService } from '@/services/exam/question.service';
import { CosService } from '@/services/cosmaz.service';
import { logger } from '@/utils';
import { ExamService } from '@/services/exam/exam.service';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _this = this;
    var recordVideoService = useService(RecordVideoService);
    var screenMediaService = useService(ScreenMediaService);
    var cosService = useService(CosService);
    var examService = useService(ExamService);
    var questionService = useService(QuestionService);
    var route = useRoute();
    var videoRef = ref(null);
    var loading = ref(false);
    var uploadUrl = ref('');
    var handleOk = function () {
      screenMediaService.showVideoPreview(false);
    };
    var onRecordAgain = function () {
      var _a, _b, _c, _d;
      if (videoRef.value) {
        videoRef.value.pause();
      }
      screenMediaService.initRecordState();
      recordVideoService.reGetRecordLogic();
      screenMediaService.showVideoPreview(false);
      try {
        window.hetaoTrack('element_click', {
          elementName: '重新录制',
          pageName: '赛事录屏页面',
          uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
          userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
          examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
        });
        // eslint-disable-next-line
      } catch (e) {}
    };
    var onUpload = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var response, fileName, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!screenMediaService.blobData) return [2 /*return*/];
              _a.label = 1;
            case 1:
              _a.trys.push([1, 4,, 5]);
              loading.value = true;
              response = void 0;
              if (!!uploadUrl.value) return [3 /*break*/, 3];
              fileName = cosService.getBlobName('/contest-recorder', '.mp4');
              return [4 /*yield*/, cosService.uploadBlob({
                blob: screenMediaService.blobData,
                fileName: fileName,
                cosType: 'introductionVideo'
              })];
            case 2:
              response = _a.sent();
              uploadUrl.value = (response === null || response === void 0 ? void 0 : response.Location) || '';
              _a.label = 3;
            case 3:
              logger.info('文件上传成功', response);
              // 操作来源,包括submitExam-考试页面,
              // contestList-赛事列表页面
              examService.uploadRecordVideoData({
                url: uploadUrl.value,
                optSource: recordVideoService.isVisibleCheck ? 'submitExam' : 'contestList'
              }).then(function () {
                screenMediaService.showVideoPreview(false);
                recordVideoService.hideRecordCom();
                _message.success('提交成功', 2, function () {
                  window.location.replace("/userexam/".concat(route.params.id, "/").concat(route.params.answerId, "/").concat(route.params.suffix));
                });
              }).finally(function () {
                loading.value = false;
              });
              return [3 /*break*/, 5];
            case 4:
              error_1 = _a.sent();
              _message.error("\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25");
              loading.value = false;
              return [3 /*break*/, 5];
            case 5:
              return [2 /*return*/];
          }
        });
      });
    };
    var handleAfterClose = function () {
      screenMediaService.videoPreviewConfig.urlPreview = false;
      uploadUrl.value = '';
    };
    var onClose = function () {
      if (videoRef.value) {
        videoRef.value.pause();
      }
      screenMediaService.videoPreviewConfig.showPreview = false;
    };
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_modal, {
        visible: _unref(screenMediaService).videoPreviewConfig.showPreview,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _unref(screenMediaService).videoPreviewConfig.showPreview = $event;
        }),
        title: "",
        onOk: handleOk,
        onAfterClose: handleAfterClose,
        width: "950px",
        centered: "",
        wrapClassName: "video-preview-modal__recorder",
        closable: false,
        footer: null,
        maskClosable: false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_unref(screenMediaService).blobUrl ? (_openBlock(), _createElementBlock("video", {
            key: 0,
            src: _unref(screenMediaService).blobUrl,
            ref: function (_value, _refs) {
              _refs['videoRef'] = _value;
              videoRef.value = _value;
            },
            controls: ""
          }, null, 8, _hoisted_3)) : _createCommentVNode("", true)]), _unref(screenMediaService).videoPreviewConfig.urlPreview ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_a_button, {
            type: "primary",
            class: "submit",
            onClick: onClose
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_a_button, {
            type: "primary",
            ghost: "",
            class: "re-recorder",
            onClick: onRecordAgain
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 1
          }), _createVNode(_component_a_button, {
            type: "primary",
            class: "submit",
            onClick: onUpload,
            loading: loading.value
          }, {
            default: _withCtx(function () {
              return [_hoisted_8];
            }),
            _: 1
          }, 8, ["loading"])]))])];
        }),
        _: 1
      }, 8, ["visible"])]);
    };
  }
});